import type { ja } from './lang-ja';
import { LangComEn } from '@/locales/lang-com-en';
export const en: typeof ja = {
  com: LangComEn,
  dateLabel: 'Date: January 28, 2026',
  title: 'Notice Regarding Impersonation Accounts Claiming to Represent Our Company President',
  body: `Thank you for visiting the INSPIRE LLC website.

We would like to inform you that we have confirmed the existence of unauthorized impersonation accounts on certain chat and messaging services that falsely claim to represent the president of INSPIRE LLC.

These accounts are operated by third parties and have no affiliation whatsoever with INSPIRE LLC or with our company president.
INSPIRE LLC has not created, used, or been involved in any way with these accounts.

Official communications from INSPIRE LLC are conducted only through the contact information listed on this website,
as well as through official communication channels that have been mutually confirmed in the course of existing business relationships.

If you receive any suspicious communications claiming to be from our company president or from representatives of INSPIRE LLC,
please refrain from responding and contact us via the inquiry form on this website.

We have reported this matter to the relevant service providers and are currently working with them to ensure appropriate action is taken.

We appreciate your understanding and cooperation.`,
  requestLink: 'Contact us',
};
